import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { IDownloadResultsPackageAPIResponse } from '@models';
import {
  parseReasonForCreationData,
  packageSummaryDataList,
} from '../../helpers/results-package-helper';
import PackageSummaryHeaders from './PackageSummaryHeaders';
import PackageSummaryValues from './PackageSummaryValues';
import './PackageSummaryContainer.scss';

interface PackageSummaryContainerProps {
  downloadPackage: IDownloadResultsPackageAPIResponse;
  timezone: string;
  uiSummaryListLength: number;
}

const PackageSummaryContainer: React.FC<PackageSummaryContainerProps> = ({
  downloadPackage,
  uiSummaryListLength,
  timezone,
}) => {
  const { t } = useTranslation();
  return (
    <Col className='summary-container'>
      <PackageSummaryHeaders
        summaryList={packageSummaryDataList}
      ></PackageSummaryHeaders>
      <PackageSummaryValues
        data={downloadPackage}
        summaryList={packageSummaryDataList}
        timezone={timezone}
        uiSummaryListLength={uiSummaryListLength}
      ></PackageSummaryValues>
      <Row className='reason-container'>
        <Col xs className='pr-0'>
          <p className='font-size-9 font-weight-semi-bold fcolor--text-label summary-header-cell'>
            {t('downloadResultsPkg_summary_pkgReasonForCreation').toUpperCase()}
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs className='pr-0'>
          <p className='font-size-12 font-weight-semi-bold m-0'>
            {parseReasonForCreationData(downloadPackage, t)}
          </p>
        </Col>
      </Row>
    </Col>
  );
};

export default PackageSummaryContainer;
